export default "__VITE_ASSET__9f7c8b2f__"